import React, { createContext, useContext, useState } from 'react';
import { ProjectFilesUrlModal } from './project-files-url-modal';

interface ProjectFilesUrlModalContextType {
  openModal: (params: {
    requestId: string;
    initialValue?: string;
    onSubmit: (url: string) => void;
    title?: string;
    description?: string;
  }) => void;
  closeModal: () => void;
  isOpen: boolean;
}

const ProjectFilesUrlModalContext = createContext<ProjectFilesUrlModalContextType>({
  openModal: () => {},
  closeModal: () => {},
  isOpen: false,
});

export const ProjectFilesUrlModalProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalProps, setModalProps] = useState<{
    requestId: string;
    initialValue?: string;
    onSubmit: (url: string) => void;
    title?: string;
    description?: string;
  } | null>(null);

  const openModal = (params: {
    requestId: string;
    initialValue?: string;
    onSubmit: (url: string) => void;
    title?: string;
    description?: string;
  }) => {
    setModalProps(params);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <ProjectFilesUrlModalContext.Provider value={{ openModal, closeModal, isOpen }}>
      {children}
      {modalProps && (
        <ProjectFilesUrlModal
          isOpen={isOpen}
          onClose={closeModal}
          requestId={modalProps.requestId}
          initialValue={modalProps.initialValue}
          onSubmit={modalProps.onSubmit}
          title={modalProps.title}
          description={modalProps.description}
        />
      )}
    </ProjectFilesUrlModalContext.Provider>
  );
};

export const useProjectFilesUrlModal = () => useContext(ProjectFilesUrlModalContext);
